import { type FC, useEffect, useRef, useState } from 'react';

const PHRASES = [
  'Searching…',
  'Analysing…',
  'Crunching…',
  'Fetching…',
  'Processing…',
  'Digging…',
  'Computing…',
  'Defrosting…',
  'Calibrating…',
  'Wiring…',
  'Daving…',
  'Heating…',
  'Solarising…',
];

const CYCLE_MS = 10_000;

export const ToolStatusIndicator: FC = () => {
  const [index, setIndex] = useState(() =>
    Math.floor(Math.random() * PHRASES.length)
  );
  const [visible, setVisible] = useState(true);

  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    const id = setInterval(() => {
      // Fade out, swap phrase, fade back in
      setVisible(false);
      timeoutRef.current = setTimeout(() => {
        setIndex((prev) => (prev + 1) % PHRASES.length);
        setVisible(true);
      }, 200);
    }, CYCLE_MS);

    return () => {
      clearInterval(id);
      clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <div className="flex items-center gap-2 py-1 text-sm text-gray-500">
      <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600" />
      <span
        className="transition-opacity duration-200"
        style={{ opacity: visible ? 1 : 0 }}
      >
        {PHRASES[index]}
      </span>
    </div>
  );
};
